import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteGoalsGoalShortTermGoals } from './ShortTermGoals'
import { PatientCareCenterNoteGoalsLTGs } from './LTGs';

class PatientCareCenterNoteGoalsBody extends React.Component {

    render() {

        return (
            <div>
                <PatientCareCenterNoteGoalsGoalShortTermGoals />
                <PatientCareCenterNoteGoalsLTGs subjectiveRefProp={this.props.subjectiveRefProp} />
            </div>
        );
    }

}


const connectedPatientCareCenterNoteGoalsBody = connect()(PatientCareCenterNoteGoalsBody);
export { connectedPatientCareCenterNoteGoalsBody as PatientCareCenterNoteGoalsBody };

